export const boLinkPreviews = ['#/users'] as const;

export type BoLinkPreviews = (typeof boLinkPreviews)[number];
